import React, { useState } from 'react';
import { Box, CardContent, Typography, TextField, InputAdornment, FormControlLabel, Switch, Button } from '@mui/material';
import { StorefrontOutlined, Search, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { PageContainer, PageCard, SectionHeader } from '../../common/components/styled-ui-elements';
import { BackToDashboardButton } from '../../common/components/navigation';
import { VendorsGrid } from '../components/VendorList';

const VendorList: React.FC = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [showInactive, setShowInactive] = useState(false);

  return (
    <PageContainer sx={{ backgroundColor: '#f8fafc' }}>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Professional Header */}
          <Box sx={{ 
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5
          }}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <Box>
                <SectionHeader 
                  icon={<StorefrontOutlined sx={{ mr: 1, color: '#7c3aed' }} />}
                  title="Vendor Management"
                />
                <Typography 
                  variant="body2" 
                  sx={{ color: '#64748b', ml: 4 }}
                >
                  Manage vendors, contacts, and supplier information
                </Typography>
              </Box>
              <Box display="flex" gap={1}>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => navigate('/vendors/create')}
                  sx={{
                    backgroundColor: '#162346',
                    '&:hover': { backgroundColor: '#1a2a52' },
                    fontWeight: 600,
                    textTransform: 'none',
                    px: 2.5,
                  }}
                >
                  Create Vendor
                </Button>
                <BackToDashboardButton />
              </Box>
            </Box>
          </Box>
          
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            {/* Search and Filter Section */}
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <TextField
                size="small"
                placeholder="Search vendors by name, number, contact..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ flex: 1, maxWidth: 500 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: '#94a3b8' }} />
                    </InputAdornment>
                  ),
                }}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={showInactive}
                    onChange={(e) => setShowInactive(e.target.checked)}
                    size="small"
                  />
                }
                label={
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    Show Inactive
                  </Typography>
                }
              />
            </Box>

            {/* Grid Section */}
            <VendorsGrid 
              searchText={searchText}
              showInactive={showInactive}
            />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default VendorList;
